import { Rise, Overline } from "@/components/Reveal";

export const HOME_FAQ = [
  {
    q: "Where is F. Drury & Sons based?",
    a: "F. Drury & Sons is at The Abattoir, Tockenham, Wootton Bassett, Swindon, Wiltshire, SN4 7PF — a short drive from Swindon town centre, just off the A3102.",
  },
  {
    q: "How do I open a wholesale account?",
    a: "We supply restaurants, farm shops and independent butchers across Wiltshire, Swindon and the South West. Use the enquiry form on our Wholesale page, download the Wholesale Account Application PDF from the footer, or call the abattoir on 01793 852467 to discuss your requirements.",
  },
  {
    q: "Do you offer full traceability?",
    a: "Yes. Every animal is tracked from arrival to dispatch through our in-house system, and CCTV runs across all aspects of production, monitored by a dedicated Quality Assurance team.",
  },
  {
    q: "How long has F. Drury & Sons been trading?",
    a: "Over one hundred years. The family trade at Tockenham dates back to around 1924, and F. Drury & Sons Limited was formally incorporated on 5 September 1958 (Companies House number 00610856).",
  },
  {
    q: "Can I order a whole or half animal, or a bulk cut?",
    a: "Yes — we can arrange whole or half beef and lamb, cut and packed to your requirements. Call the abattoir on 01793 852467 to discuss booking, timing and cutting instructions.",
  },
  {
    q: "What paperwork do I need to bring with livestock?",
    a: "We ask every consignment to arrive with a signed Food Chain Information (FCI) declaration and a Livestock Movement Declaration. Both are downloadable as PDFs from the footer of this page.",
  },
];

export const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: HOME_FAQ.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  return (
    <section
      id="faq"
      aria-labelledby="faq-heading"
      className="relative py-16 md:py-32 bg-[color:var(--cream)] border-t border-[color:var(--hairline)]"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid grid-cols-12 gap-6 md:gap-16">
        <div className="col-span-12 md:col-span-5">
          <Rise>
            <Overline>Frequently asked</Overline>
            <h2
              id="faq-heading"
              className="mt-4 md:mt-6 font-display text-[10vw] sm:text-5xl md:text-6xl leading-[0.95] tracking-tightest"
            >
              Answers before you <span className="italic text-[color:var(--oxblood)]">ring us.</span>
            </h2>
          </Rise>
          <Rise delay={0.1}>
            <p className="mt-5 md:mt-6 font-body text-base md:text-lg text-[color:var(--ink-light)] leading-relaxed max-w-md">
              A short list of things we're most often asked. Anything else? Call the abattoir on 01793 852467 or drop us a message.
            </p>
          </Rise>
        </div>

        <div className="col-span-12 md:col-span-7">
          <dl className="divide-y divide-[color:var(--hairline)] border-t border-[color:var(--hairline)]">
            {HOME_FAQ.map((f, i) => (
              <Rise key={f.q} delay={i * 0.03}>
                <details className="group py-6 md:py-8">
                  <summary className="flex items-start justify-between gap-6 cursor-pointer list-none">
                    <dt className="font-display italic text-xl md:text-3xl text-[color:var(--ink)] leading-snug pr-4">
                      {f.q}
                    </dt>
                    <span
                      aria-hidden="true"
                      className="mt-2 shrink-0 font-display text-2xl md:text-3xl text-[color:var(--oxblood)] transition-transform duration-500 group-open:rotate-45"
                    >
                      +
                    </span>
                  </summary>
                  <dd className="mt-4 md:mt-5 font-body text-base md:text-lg text-[color:var(--ink-light)] leading-relaxed max-w-2xl">
                    {f.a}
                  </dd>
                </details>
              </Rise>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
